module.exports = "https://cdn.realtymogul.com/static/media/icon_talk.19fec0ba.svg";